import { __decorate, __metadata } from "tslib";
import { elementDefine, onConnectedBodyShadow, onConnectedBefore, subscribeSwcAppRouteChange, innerHtmlLight, innerHtml, attribute, replaceChildren, skipIfExists, } from '@dooboostore/simple-web-component';
const tagName = 'center-root-router';
export default (w) => {
    var _a;
    const existing = w.customElements.get(tagName);
    if (existing)
        return tagName;
    let RootRouter = class RootRouter extends w.HTMLElement {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "router", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        onRouteChange(routerPathSet) {
            console.log("[Route Change]", routerPathSet.path);
        }
        handleHome() {
            return `<center-home-page/>`;
        }
        handleEnglishList() {
            return `<center-english-list-page/>`;
        }
        handleEnglishPlayer(routerPathSet) {
            return `<center-english-player-page name="${routerPathSet.pathData.name}"/>`;
        }
        handleTextEnglishList() {
            return `<center-text-english-list-page/>`;
        }
        handleTextEnglishReader(routerPathSet) {
            return `<center-text-english-reader-page name="${routerPathSet.pathData.name}"/>`;
        }
        handleStockFlight() {
            return `<center-stock-flight-page/>`;
        }
        handleLotto() {
            return `<center-lotto-page/>`;
        }
        handleCoordinateSimulation() {
            return `<center-coordinate-2d-simulation-page/>`;
        }
        handleBuyback() {
            return `<center-buyback-page/>`;
        }
        handleStockBrainChecker() {
            return `<center-stock-brain-checker-page/>`;
        }
        handleStockNpti() {
            return `<center-stock-npti-page/>`;
        }
        handleStockCategory() {
            return `<center-stock-category-page/>`;
        }
        handleStockIndicator() {
            return `<center-stock-indicator-page/>`;
        }
        handleStockChart() {
            return `<center-stock-chart-page/>`;
        }
        handleGpuRental() {
            return `<center-gpu-rental-page/>`;
        }
        handleStockCategoryRanking() {
            return `<center-stock-category-ranking-page/>`;
        }
        handleStockTradingSimulation() {
            return `<center-stock-trading-simulation-page/>`;
        }
        handleMath() {
            return `<center-math-page/>`;
        }
        handleRamPrice() {
            return `<center-ram-price-page/>`;
        }
        handlePhysical() {
            return `<center-physical-page/>`;
        }
        handleVision() {
            return `<center-vision-page/>`;
        }
        handleRos2() {
            return `<center-ros2-page/>`;
        }
        handleAi() {
            return `<center-ai-page/>`;
        }
        handle404() {
            return `<div style="display: flex; align-items: center; justify-content: center; min-height: 400px; text-align: center; color: #666;">
        <div>
          <h2 style="font-size: 24px; margin-bottom: 10px; color: #333;">404 - Page Not Found</h2>
          <p style="margin-bottom: 20px; color: #999;">The page you're looking for doesn't exist.</p>
          <a href="/" style="padding: 12px 24px; background: #1976d2; color: white; text-decoration: none; border-radius: 4px; font-weight: 600;">Go Home</a>
        </div>
      </div>`;
        }
        renderContent(node) {
            return node;
        }
        setMeta() {
            return {
                titleBody: "@dooboostore Center",
                ogTitle: "@dooboostore Center",
                desc: "다양한 미니 앱들을 한 곳에서 만나보세요.",
                ogDesc: "다양한 미니 앱들을 한 곳에서 만나보세요.",
            };
        }
        // @event<InputEvent>("#input", "input", {
        //   debounceTime: 1000,
        //   distinctUntilChanged: (a, b) => {
        //     return a.data === b.data;
        //   },
        // })
        // inputHandler(event: Event) {
        //   console.log("----->", event);
        // }
        render() {
            return `
        <style>
          * { box-sizing: border-box; }
          :host { display: flex; flex-direction: column; min-height: 100vh; width: 100%; background: #fff; }
          #page-container { flex: 1; display: flex; flex-direction: column; width: 100%; }
        </style>
<!--        <input id="input" type="text">-->
        <main id="page-container">
          <slot></slot>
        </main>
      `;
        }
    };
    __decorate([
        subscribeSwcAppRouteChange({ order: -1 }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "onRouteChange", null);
    __decorate([
        subscribeSwcAppRouteChange(["", "/"], { order: 0 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleHome", null);
    __decorate([
        subscribeSwcAppRouteChange(["/english"], { order: 1 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleEnglishList", null);
    __decorate([
        subscribeSwcAppRouteChange(['/english/{name}'], { order: 2 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleEnglishPlayer", null);
    __decorate([
        subscribeSwcAppRouteChange(["/text-english"], { order: 2 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleTextEnglishList", null);
    __decorate([
        subscribeSwcAppRouteChange(['/text-english/{name}'], { order: 2 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleTextEnglishReader", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-flight"], { order: 3 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockFlight", null);
    __decorate([
        subscribeSwcAppRouteChange(["/lotto"], { order: 4 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleLotto", null);
    __decorate([
        subscribeSwcAppRouteChange(["/coordinate-simulation"], { order: 5 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleCoordinateSimulation", null);
    __decorate([
        subscribeSwcAppRouteChange(["/buyback"], { order: 6 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleBuyback", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-brain-checker"], { order: 7 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockBrainChecker", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-npti"], { order: 8 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockNpti", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-category"], { order: 9 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockCategory", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-indicator"], { order: 9 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockIndicator", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-chart"], { order: 9 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockChart", null);
    __decorate([
        subscribeSwcAppRouteChange(["/gpu-rental"], { order: 9 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleGpuRental", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-category-ranking"], { order: 9 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockCategoryRanking", null);
    __decorate([
        subscribeSwcAppRouteChange(["/stock-trading-simulation"], { order: 10 }),
        innerHtmlLight({ filter: skipIfExists('center-stock-trading-simulation-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleStockTradingSimulation", null);
    __decorate([
        subscribeSwcAppRouteChange(["/math"], { order: 11 }),
        innerHtmlLight({ filter: skipIfExists('center-math-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleMath", null);
    __decorate([
        subscribeSwcAppRouteChange(["/ram-price"], { order: 12 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleRamPrice", null);
    __decorate([
        subscribeSwcAppRouteChange(["/physical"], { order: 13 }),
        innerHtmlLight({ filter: skipIfExists('center-physical-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handlePhysical", null);
    __decorate([
        subscribeSwcAppRouteChange(["/vision"], { order: 14 }),
        innerHtmlLight({ filter: skipIfExists('center-vision-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleVision", null);
    __decorate([
        subscribeSwcAppRouteChange(["/ros2"], { order: 15 }),
        innerHtmlLight({ filter: skipIfExists('center-ros2-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleRos2", null);
    __decorate([
        subscribeSwcAppRouteChange(["/ai"], { order: 16 }),
        innerHtmlLight({ filter: skipIfExists('center-ai-page') }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handleAi", null);
    __decorate([
        subscribeSwcAppRouteChange(["/{tail:.*}"], { order: 999 }),
        innerHtmlLight,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "handle404", null);
    __decorate([
        replaceChildren({
            root: "light",
            filter: (host, newNode) => !host.contains(newNode),
        }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Node !== "undefined" && Node) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "renderContent", null);
    __decorate([
        onConnectedBefore,
        innerHtml((c, helper) => helper.$w.document.querySelector("title"), { valueKey: "titleBody" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:title"]'), "content", { valueKey: "ogTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="description"]'), "content", { valueKey: "desc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:description"]'), "content", { valueKey: "ogDesc" }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "setMeta", null);
    __decorate([
        onConnectedBodyShadow,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RootRouter.prototype, "render", null);
    RootRouter = __decorate([
        elementDefine(tagName, { window: w })
    ], RootRouter);
    return tagName;
};
